<template>
  <div class="text-center loading-spinner-container" :style="(inline)? 'display:inline-block;':''">
    <fa icon="spinner" spin /> <slot v-if="!noText">
      Loading
    </slot>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    inline: {
      type: Boolean,
      required: false,
      default: true
    },
    noText: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
